"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFromApiFormat = transformFromApiFormat;
const moment_1 = __importDefault(require("moment"));
const account_1 = require("@src/types/account");
function transformFromApiFormat(profileResume) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const profileResumeFields = {
        firstName: profileResume.first_name,
        lastName: profileResume.last_name,
        titleAfter: profileResume.title_after,
        titleBefore: profileResume.title_before,
        sex: profileResume.sex,
        description: profileResume.description,
        birthDate: (0, moment_1.default)(profileResume.birth_date).isValid() ? (0, moment_1.default)(profileResume.birth_date) : undefined,
        address: {
            google_place_id: (_a = profileResume.address) === null || _a === void 0 ? void 0 : _a.google_place_id,
            formatted_address: (_b = profileResume.address) === null || _b === void 0 ? void 0 : _b.formatted_address,
            country: (_c = profileResume.address) === null || _c === void 0 ? void 0 : _c.country,
        },
        phoneNumber: profileResume.telephone,
        portfolio: profileResume.portfolio,
        facebookUrl: profileResume.facebook_url,
        instagramUrl: profileResume.instagram_url,
        twitterUrl: profileResume.twitter_url,
        linkedinUrl: profileResume.linkedin_url,
        youtubeUrl: profileResume.youtube_url,
        driverLicence: ((_d = profileResume.driver_licence) === null || _d === void 0 ? void 0 : _d.split(',')) || undefined,
    };
    const certificates = [];
    const jobExperience = [];
    const schoolExperience = [];
    const languages = [];
    const skillTags = [];
    (_e = profileResume.account_languages) === null || _e === void 0 ? void 0 : _e.forEach(lang => {
        languages.push({ languageCode: lang.language_code, languageLevel: lang.level });
    });
    (_f = profileResume.account_skills) === null || _f === void 0 ? void 0 : _f.forEach(({ value, rating, isPrimary }) => {
        const formattedAccountSkills = { value, label: value, rating: rating || 1, isPrimary };
        skillTags.push(formattedAccountSkills);
    });
    (_g = profileResume.account_profile_experience) === null || _g === void 0 ? void 0 : _g.forEach(accountProfileExperience => {
        var _a;
        const matchedProfileExperience = (_a = profileResume.profile_experience) === null || _a === void 0 ? void 0 : _a.find(profileExperience => profileExperience.id === accountProfileExperience.profile_experience_id);
        switch (matchedProfileExperience === null || matchedProfileExperience === void 0 ? void 0 : matchedProfileExperience.type) {
            case account_1.ProfileExperienceType.job:
                jobExperience.push({
                    description: accountProfileExperience.description,
                    positionName: accountProfileExperience.title,
                    dateFrom: (0, moment_1.default)(accountProfileExperience.from),
                    dateTo: (0, moment_1.default)(accountProfileExperience.to).isValid()
                        ? (0, moment_1.default)(accountProfileExperience.to)
                        : undefined,
                    stillActual: !accountProfileExperience.to,
                    employerName: matchedProfileExperience.name,
                    skillsUsed: accountProfileExperience.skillsUsed,
                });
                break;
            case account_1.ProfileExperienceType.school:
                schoolExperience.push({
                    description: accountProfileExperience.description,
                    sectionName: accountProfileExperience.title,
                    dateFrom: (0, moment_1.default)(accountProfileExperience.from),
                    dateTo: (0, moment_1.default)(accountProfileExperience.to).isValid()
                        ? (0, moment_1.default)(accountProfileExperience.to)
                        : undefined,
                    stillActual: !accountProfileExperience.to,
                    schoolName: matchedProfileExperience.name,
                });
                break;
            case account_1.ProfileExperienceType.certificate:
                certificates.push({
                    certificateName: accountProfileExperience.title,
                    expirationDate: (0, moment_1.default)(accountProfileExperience.to).isValid()
                        ? (0, moment_1.default)(accountProfileExperience.to)
                        : undefined,
                    issueDate: (0, moment_1.default)(accountProfileExperience.from),
                    issuingOrganization: matchedProfileExperience.name,
                    withoutExpiration: !(0, moment_1.default)(accountProfileExperience.to).isValid(),
                });
                break;
            // no default
        }
    });
    profileResumeFields.rateSkills = Boolean((_h = profileResume.account_skills) === null || _h === void 0 ? void 0 : _h.find(skill => skill.rating));
    if (certificates.length) {
        profileResumeFields.certificates = certificates;
    }
    if (jobExperience.length) {
        profileResumeFields.jobExperience = jobExperience;
    }
    if (languages.length) {
        profileResumeFields.profileLanguage = languages;
    }
    if (schoolExperience.length) {
        profileResumeFields.schoolExperience = schoolExperience;
    }
    if (skillTags.length) {
        profileResumeFields.profileSkills = skillTags;
    }
    return profileResumeFields;
}
